import React from 'react';

const Step2 = ({ formData, setFormData, nextStep, prevStep }) => {
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLoanAmountChange = (e) => {
    let value = e.target.value.replace(/,/g, '');
    value = value.replace(/[^0-9]/g, '');
    let numValue = value ? parseInt(value) : '';
    // Only validate that it's a positive number, no min/max limits
    if (numValue !== '' && numValue < 0) numValue = 0;
    setFormData({ ...formData, loanAmount: numValue });
  };

  const formatAmount = (amount) => {
    if (!amount && amount !== 0) return '';
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const calculateEMI = () => {
    const principal = formData.loanAmount || 0;
    const ratePerMonth = (formData.interestRate || 6) / (12 * 100);
    const months = formData.tenure || 12;
    if (principal && principal > 0 && months) {
      const emi = principal * ratePerMonth * Math.pow(1 + ratePerMonth, months) / (Math.pow(1 + ratePerMonth, months) - 1);
      return isNaN(emi) ? 0 : emi;
    }
    return 0;
  };

  const emi = calculateEMI();
  const totalPayable = emi * (formData.tenure || 12);
  const totalInterest = totalPayable - (formData.loanAmount || 0);

  const tenureOptions = [12, 24, 36, 48, 60, 72, 84, 96, 108, 120];

  const isValid = () => {
    return formData.loanAmount && 
           formData.loanAmount > 0 && 
           formData.tenure && 
           formData.loanPurpose && 
           formData.employmentType;
  };

  return (
    <div className="step-container">
      <div className="step-header">
        <div className="step-number">2</div>
        <div className="step-title">
          <h3>Loan Details</h3>
          <p>Tell us how much you need</p>
        </div>
      </div>

      <div className="step-form">
        <div className="form-group">
          <label>Loan Amount (₹) *</label>
          <input
            type="text"
            name="loanAmount"
            value={formatAmount(formData.loanAmount)}
            onChange={handleLoanAmountChange}
            placeholder="Enter loan amount"
            className="loan-amount-input"
          />
          <div className="amount-hint">
            <span>Enter any amount you need</span>
          </div>
        </div>

        <div className="form-group">
          <label>Interest Rate (% p.a.) *</label>
          <div className="amount-slider">
            <input
              type="range"
              min="3"
              max="9"
              step="0.5"
              name="interestRate"
              value={formData.interestRate || 6}
              onChange={handleChange}
            />
            <div className="amount-values">
              <span>3%</span>
              <span>9%</span>
            </div>
            <div className="amount-display">
              <span className="value">{formData.interestRate || 6}% per annum</span>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label>Tenure (Months) *</label>
          <div className="tenure-options">
            {tenureOptions.map((t) => (
              <button
                key={t}
                type="button"
                className={`tenure-option ${formData.tenure === t ? 'active' : ''}`}
                onClick={() => setFormData({ ...formData, tenure: t })}
              >
                {t} Months
              </button>
            ))}
          </div>
        </div>

        {formData.loanAmount > 0 && (
          <div className="loan-summary">
            <div className="summary-item">
              <span>Monthly EMI</span>
              <strong>₹{emi.toFixed(2)}</strong>
            </div>
            <div className="summary-item">
              <span>Total Interest</span>
              <strong>₹{totalInterest.toFixed(2)}</strong>
            </div>
            <div className="summary-item">
              <span>Total Amount</span>
              <strong>₹{totalPayable.toFixed(2)}</strong>
            </div>
            <div className="summary-item">
              <span>Interest Rate</span>
              <strong>{formData.interestRate || 6}% p.a.</strong>
            </div>
          </div>
        )}

        <div className="form-row">
          <div className="form-group">
            <label>Loan Purpose *</label>
            <select name="loanPurpose" value={formData.loanPurpose} onChange={handleChange} required>
              <option value="">Select purpose of loan</option>
              <option value="personal">Personal Loan</option>
              <option value="home">Home Loan / Renovation</option>
              <option value="car">Car / Vehicle Loan</option>
              <option value="education">Education Loan</option>
              <option value="business">Business Expansion</option>
              <option value="medical">Medical Emergency</option>
              <option value="wedding">Wedding / Family Function</option>
              <option value="travel">Travel / Vacation</option>
            </select>
          </div>
          <div className="form-group">
            <label>Employment Type *</label>
            <select name="employmentType" value={formData.employmentType} onChange={handleChange} required>
              <option value="">Select employment type</option>
              <option value="salaried">Salaried Employee</option>
              <option value="self-employed">Self Employed Professional</option>
              <option value="business">Business Owner</option>
              <option value="freelancer">Freelancer</option>
              <option value="government">Government Employee</option>
            </select>
          </div>
        </div>

        <div className="step-actions dual">
          <button onClick={prevStep} className="btn-prev">
            ← Back
          </button>
          <button onClick={nextStep} className="btn-next" disabled={!isValid()}>
            Continue to Documents →
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step2;